import script from "./EventBalanceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventBalanceCard.vue?vue&type=script&setup=true&lang=js"

import "./EventBalanceCard.vue?vue&type=style&index=0&id=0d938782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d938782"]])

export default __exports__